const LOCALSTORAGE_KEYS = {
  COMPARE: 'tac-hsiyc:compare',
} as const;

export default LOCALSTORAGE_KEYS;
